(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[701],{

/***/ 43383:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/relay",
      function () {
        return __webpack_require__(77813);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useNow; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96019);


const useNow = ()=>{
    const [now, setNow] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(_fp__WEBPACK_IMPORTED_MODULE_1__.O.none);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const interval = setInterval(()=>{
            setNow(_fp__WEBPACK_IMPORTED_MODULE_1__.O.some(new Date()));
        }, 1000);
        return ()=>clearInterval(interval);
    }, []);
    return now;
};


/***/ }),

/***/ 77813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ relay; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./src/components/BasicErrorBoundary.tsx
var BasicErrorBoundary = __webpack_require__(46756);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/skeleton.css
var skeleton = __webpack_require__(36860);
// EXTERNAL MODULE: ./src/colors.ts
var colors = __webpack_require__(71637);
// EXTERNAL MODULE: ./src/components/AdminTools.tsx
var AdminTools = __webpack_require__(94191);
// EXTERNAL MODULE: ./src/components/HeaderGlow/index.tsx + 1 modules
var HeaderGlow = __webpack_require__(42857);
// EXTERNAL MODULE: ./src/components/MainTitle/index.tsx
var MainTitle = __webpack_require__(6523);
// EXTERNAL MODULE: ./src/feature-flags.ts
var feature_flags = __webpack_require__(58739);
// EXTERNAL MODULE: ./src/sections/ContactSection/index.tsx + 5 modules
var ContactSection = __webpack_require__(48613);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/relay/config.ts
const networkFromEnv = ()=>{
    const rawNetwork = "holesky";
    switch(rawNetwork){
        case "mainnet":
            return "mainnet";
        case "holesky":
            return "holesky";
        case "hoodi":
            return "hoodi";
        default:
            console.warn("no NEXT_PUBLIC_NETWORK in env, defaulting to mainnet");
            return "mainnet";
    }
};
const getDomain = ()=>{
    const network = networkFromEnv();
    switch(network){
        case "holesky":
            return "https://relay-stag.ultrasound.money";
        case "hoodi":
            return "https://relay-hoodi.ultrasound.money";
        case "mainnet":
        default:
            return "https://relay.ultrasound.money";
    }
};
const getCensorshipDomain = ()=>{
    const network = networkFromEnv();
    switch(network){
        case "holesky":
            return "https://relay.ultrasound.money";
        case "hoodi":
            return "https://relay-hoodi.ultrasound.money";
        case "mainnet":
        default:
            return "https://relay.ultrasound.money";
    }
};
const getRelayUrl = ()=>{
    const network = networkFromEnv();
    switch(network){
        case "holesky":
            return "https://0xb1559beef7b5ba3127485bbbb090362d9f497ba64e177ee2c8e7db74746306efad687f2cf8574e38d70067d40ef136dc@relay-stag.ultrasound.money";
        case "hoodi":
            return "https://0xb1559beef7b5ba3127485bbbb090362d9f497ba64e177ee2c8e7db74746306efad687f2cf8574e38d70067d40ef136dc@relay-hoodi.ultrasound.money";
        case "mainnet":
            return "https://0xa1559ace749633b997cb3fdacffb890aeebdb0f5a3b6aaa7eeeaf1a38af0a8fe88b9e4b1f61f236d2e64d95733327a62@relay.ultrasound.money";
    }
};
const getRelayDisplayUrl = ()=>{
    const network = networkFromEnv();
    switch(network){
        case "holesky":
            return {
                pubkey: "0xb1559...",
                host: "relay-stag.ultrasound.money"
            };
        case "hoodi":
            return {
                pubkey: "0xb1559...",
                host: "relay-hoodi.ultrasound.money"
            };
        case "mainnet":
            return {
                pubkey: "0xa1559...",
                host: "relay.ultrasound.money"
            };
    }
};
const getEtherscanUrl = ()=>{
    const network = networkFromEnv();
    return network === "holesky" ? "https://holesky.etherscan.io" : network === "hoodi" ? "https://hoodi.etherscan.io" : "https://etherscan.io";
};
const getBeaconchainUrl = ()=>{
    const network = networkFromEnv();
    return network === "holesky" ? "https://holesky.beaconcha.in" : network === "hoodi" ? "https://hoodi.beaconcha.in" : "https://beaconcha.in";
};

// EXTERNAL MODULE: ./src/components/BlueButton.tsx + 1 modules
var BlueButton = __webpack_require__(3680);
// EXTERNAL MODULE: ./src/components/WidgetSubcomponents/index.tsx
var WidgetSubcomponents = __webpack_require__(69443);
// EXTERNAL MODULE: ./src/components/TextsNext/LabelText.tsx
var LabelText = __webpack_require__(89802);
;// CONCATENATED MODULE: ./src/relay/components/AddressWidget.tsx






const address = getRelayUrl();
const displayAddress = getRelayDisplayUrl();
const AddressWidget = ()=>{
    const [copyTextVisible, setCopyTextVisible] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidgetSubcomponents/* WidgetBackground */.K, {
        className: "relative w-full overflow-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "\n            pointer-events-none absolute\n            top-10 left-0 h-full\n            w-full opacity-[0.3]\n            blur-[70px]\n            will-change-transform\n            md:left-20\n            md:opacity-[0.35]\n          ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "\n              pointer-events-none\n              absolute h-4/5 w-4/5 rounded-[35%] bg-[#243AFF]\n              md:h-3/5\n              md:w-3/5\n            "
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                        children: "relay address"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "\n            font-inter font-light text-green-400\n            ".concat(copyTextVisible ? "visible" : "invisible", "\n        "),
                        children: "copied!"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "\n            mt-2 mb-2 flex flex-col items-center justify-between\n            xs:flex-col sm:flex-row\n            lg:flex-col xl:flex-row\n         ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "\n            mb-3 break-all font-roboto font-light\n            sm:mb-0 sm:grow sm:text-center lg:mb-3 xl:mb-0\n          ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "bg-gradient-to-r from-orange-400 to-yellow-300 bg-clip-text text-transparent",
                                children: displayAddress.pubkey
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "@"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "bg-gradient-to-r from-cyan-300 to-indigo-500 bg-clip-text text-transparent",
                                children: displayAddress.host
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: ()=>{
                            navigator.clipboard.writeText(address).catch((err)=>{
                                console.error("failed to write to clipboard", err);
                            });
                            setCopyTextVisible(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlueButton/* default */.Z, {
                            children: "copy"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_AddressWidget = (AddressWidget);

;// CONCATENATED MODULE: ./src/relay/components/CheckRegistrationWidget.tsx






const CheckRegistrationWidget = ()=>{
    const [addr, setAddr] = (0,react.useState)("");
    const [registrationStatus, setRegistrationStatus] = (0,react.useState)("initial");
    const apiUrl = getDomain();
    const fetchRegistrationStatus = ()=>{
        if (addr.length > 0) {
            fetch("".concat(apiUrl, "/api/validators/").concat(addr)).then((res)=>res.json()).then((param)=>{
                let { status  } = param;
                if (status) {
                    setRegistrationStatus("registered");
                } else {
                    setRegistrationStatus("not registered");
                }
            }).catch((err)=>{
                console.error("failed to fetch registration status", err);
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidgetSubcomponents/* WidgetBackground */.K, {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                        children: "check registration"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "\n            font-inter font-light\n            ".concat(registrationStatus === "initial" ? "invisible" : "visible", "\n            ").concat(registrationStatus === "registered" ? "text-green-400" : "text-red-400", "\n        "),
                        children: "".concat(registrationStatus, "!")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-2 flex flex-row items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: "\n                 mr-4 w-full rounded-full\n                 border border-slateus-500\n                 bg-slateus-800 py-1.5 pl-4\n                 font-inter text-xs font-light\n                 text-white placeholder-slateus-400 outline-none\n                 focus-within:border-slateus-400\n                 md:py-2 md:text-base\n               ",
                        placeholder: "validator address",
                        value: addr,
                        onChange: (e)=>setAddr(e.target.value)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: fetchRegistrationStatus,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlueButton/* default */.Z, {
                            children: "check"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CheckRegistrationWidget = (CheckRegistrationWidget);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInSeconds/index.js
var differenceInSeconds = __webpack_require__(11699);
// EXTERNAL MODULE: ./src/components/Texts.tsx
var Texts = __webpack_require__(90917);
// EXTERNAL MODULE: ./src/components/TextsNext/QuantifyText.tsx
var QuantifyText = __webpack_require__(90079);
// EXTERNAL MODULE: ./src/components/TextsNext/SkeletonText.tsx
var SkeletonText = __webpack_require__(7569);
// EXTERNAL MODULE: ./src/format.ts
var format = __webpack_require__(12597);
// EXTERNAL MODULE: ./src/styles/Scrollbar.module.scss
var Scrollbar_module = __webpack_require__(23195);
var Scrollbar_module_default = /*#__PURE__*/__webpack_require__.n(Scrollbar_module);
;// CONCATENATED MODULE: ./src/relay/components/InclusionsWidget.tsx











const etherscanUrl = getEtherscanUrl();
const PayloadRow = (param)=>{
    let { blockNumber , insertedAt , value  } = param;
    const [now, setNow] = (0,react.useState)();
    const truncatedValue = value.toString().substring(0, 4);
    (0,react.useEffect)(()=>{
        const interval = setInterval(()=>{
            setNow(new Date());
        }, 1000);
        return ()=>clearInterval(interval);
    }, [
        insertedAt
    ]);
    const inclusionAgo = now === undefined ? undefined : format/* formatDurationToNow */.cj(now, insertedAt);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        target: "_blank",
        rel: "noreferrer",
        href: "".concat(etherscanUrl, "/block/").concat(blockNumber),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            className: "grid grid-cols-3 hover:opacity-60",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantifyText/* default */.Z, {
                    color: "text-slateus-100",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                        width: "7rem",
                        children: format/* formatBlockNumber */.x_(blockNumber)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mr-1 text-right",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
                            font: "font-roboto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                                width: "1rem",
                                children: truncatedValue
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden md:inline",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-inter",
                                    children: " "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-extralight font-roboto text-slateus-200",
                                    children: "ETH"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-right",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantifyText/* default */.Z, {
                        unitPostfix: "ago",
                        unitPostfixColor: "text-slateus-100",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                            width: "2rem",
                            children: inclusionAgo
                        })
                    })
                })
            ]
        })
    }, blockNumber);
};
// percentage of slots included since date
const calcPercentageOfSlotsIncluded = (payloadCount, since)=>{
    const SECONDS_PER_SLOT = 12;
    const secondsSinceFirstPayload = differenceInSeconds/* default */.Z(new Date(), since);
    const slotsSinceFirstPayload = Math.round(secondsSinceFirstPayload / SECONDS_PER_SLOT);
    return payloadCount / slotsSinceFirstPayload;
};
const InclusionsWidget = (param)=>{
    let { payloadCount , totalValue , firstPayloadAt , payloads  } = param;
    const percentageSlotsIncluded = format/* formatPercentTwoDecimals */.vJ(calcPercentageOfSlotsIncluded(payloadCount, firstPayloadAt));
    const totalValueFormatted = format/* formatTwoDigit */.cI(totalValue);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-y-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidgetSubcomponents/* WidgetBackground */.K, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                        children: "inclusions"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "mt-4 text-3xl font-extralight tracking-wide",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-white font-inter",
                                children: format/* formatZeroDecimals */.UY(payloadCount)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-roboto text-slateus-200",
                                children: "blocks"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "\n          mt-4 flex flex-row justify-between\n          font-inter text-xs font-light uppercase\n          tracking-widest text-slateus-400\n         ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-slateus-200",
                                        children: percentageSlotsIncluded
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: " of\xa0blocks"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-slateus-200",
                                        children: "".concat(totalValueFormatted, " ETH")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: " total\xa0value"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetBackground */.K, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-y-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid grid-cols-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                    children: "block"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                    className: "text-right",
                                    children: "value"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                    className: "-mr-1 text-right",
                                    children: "inclusion"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "\n            -mr-3 flex max-h-[184px]\n            flex-col gap-y-4 overflow-y-auto\n            pr-1 md:max-h-[214px]\n            ".concat((Scrollbar_module_default())["styled-scrollbar-vertical"], "\n            ").concat((Scrollbar_module_default())["styled-scrollbar"], "\n          "),
                            children: payloads.map(PayloadRow)
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_InclusionsWidget = (InclusionsWidget);

// EXTERNAL MODULE: ./src/fp.ts
var fp = __webpack_require__(96019);
// EXTERNAL MODULE: ./src/mainsite/hooks/use-now.ts
var use_now = __webpack_require__(98320);
;// CONCATENATED MODULE: ./src/relay/components/ValidatorWidget.tsx










const beaconChainUrl = getBeaconchainUrl();
const ValidatorRow = (param)=>{
    let { insertedAt , index  } = param;
    const now = (0,use_now/* useNow */.m)();
    const registeredAgo = (0,fp/* pipe */.zG)(now, fp.O.map((now)=>"".concat(format/* formatDurationToNow */.cj(now, insertedAt), " ago")));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        target: "_blank",
        rel: "noreferrer",
        href: "".concat(beaconChainUrl, "/validator/").concat(index),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            className: "grid grid-cols-2 hover:opacity-60",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mr-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
                        font: "font-roboto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                            width: "1rem",
                            children: format/* formatZeroDecimals */.UY(parseInt(index))
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-right",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
                        font: "font-roboto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                            width: "2rem",
                            children: fp.O.toUndefined(registeredAgo)
                        })
                    })
                })
            ]
        })
    }, index);
};
const ValidatorWidget = (param)=>{
    let { validatorCount , knownValidatorCount , validators  } = param;
    const percentageOfValidators = format/* formatPercentTwoDecimals */.vJ(validatorCount / knownValidatorCount);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-y-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidgetSubcomponents/* WidgetBackground */.K, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                        children: "registrations"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "mt-4 text-3xl font-extralight tracking-wide",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-inter text-white",
                                children: format/* formatZeroDecimals */.UY(validatorCount)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-roboto text-slateus-200",
                                children: "validators"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "\n          mt-4 flex flex-row justify-between\n          font-inter text-xs font-light uppercase\n          tracking-widest text-slateus-400\n         ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-slateus-200",
                                    children: percentageOfValidators
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: " of\xa0validators"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetBackground */.K, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-y-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid grid-cols-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                    children: "validator"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                    className: "-mr-1 text-right",
                                    children: "registration"
                                })
                            ]
                        }),
                        validators.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "\n              -mr-3 flex max-h-[184px]\n              flex-col gap-y-4 overflow-y-auto\n              pr-1 md:max-h-[214px]\n              ".concat((Scrollbar_module_default())["styled-scrollbar-vertical"], "\n              ").concat((Scrollbar_module_default())["styled-scrollbar"], "\n            "),
                            children: validators.map(ValidatorRow)
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex h-[184px] items-center justify-center md:h-[214px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
                                font: "font-roboto",
                                color: "text-slateus-400",
                                children: "registrations unavailable"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_ValidatorWidget = (ValidatorWidget);

// EXTERNAL MODULE: ./src/components/Accordion/index.tsx
var Accordion = __webpack_require__(82770);
// EXTERNAL MODULE: ./src/components/TextsNext/SectionTitle.tsx
var SectionTitle = __webpack_require__(44759);
// EXTERNAL MODULE: ./src/contexts/NavigationContext.tsx
var NavigationContext = __webpack_require__(47387);
;// CONCATENATED MODULE: ./src/relay/copy.json
var copy_namespaceObject = JSON.parse('[{"question":"What is the ultra sound relay?","answer":"The ultra sound relay is a credibly-neutral and permissionless relay—a public good from the ultrasound.money team."},{"question":"What is a credibly-neutral relay?","answer":"A credibly-neutral relay only validates blocks against consensus rules as in enshrined proposer-builder separation."},{"question":"What is enshrined proposer-builder separation?","answer":"Enshrined proposer-builder separation (PBS) is an in-consensus PBS without relays, removing relay weak censorship."},{"question":"What is weak censorship?","answer":"Weak censorship is mild transaction censorship which increases on-chain inclusion delay of censored transactions."},{"question":"How delayed are censored transactions?","answer":"Censorship in X% of blocks yields 1/(1-X%) larger average delay. If X% = 80%, delay grows 5x from 12 sec to 1 min."},{"question":"Anything else?","answer":"The relay operators abstain from searching and block building, and commit to self-cap the relay to 1/3 of blocks."}]');
;// CONCATENATED MODULE: ./src/relay/sections/FaqSection.tsx






const calcCenterElement = (element)=>{
    const topEl = element.getBoundingClientRect().y + window.scrollY;
    const heightEl = element.clientHeight;
    // like {top: 50%, transform: translateY(-50%)} in CSS
    return topEl - window.innerHeight / 2 + heightEl / 2;
};
const FaqBlock = ()=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    const { changeFaqPosition  } = react.useContext(NavigationContext/* NavigationContext */.k);
    const faqSection = react.useRef(null);
    react.useEffect(()=>{
        const resizeFun = ()=>{
            if (faqSection.current) {
                const centerBlock = calcCenterElement(faqSection.current);
                changeFaqPosition(centerBlock);
            }
        };
        resizeFun();
        window.addEventListener("resize", resizeFun);
        return ()=>window.removeEventListener("resize", resizeFun);
    }, [
        changeFaqPosition
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "mt-64",
        ref: faqSection,
        "data-aos": "fade-up",
        "data-aos-anchor-placement": "top-center",
        "data-aos-delay": "50",
        "data-aos-duration": "1000",
        "data-aos-easing": "ease-in-out",
        id: "faq",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-3xl md:m-auto md:px-4 lg:px-0 ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "block pb-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                        children: "q&a"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full px-4 md:px-8 lg:px-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                            title: (ref = copy_namespaceObject[0]) === null || ref === void 0 ? void 0 : ref.question,
                            text: (ref1 = copy_namespaceObject[0]) === null || ref1 === void 0 ? void 0 : ref1.answer
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full bg-slateus-400",
                            style: {
                                height: "1px",
                                opacity: "0.3"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                            title: (ref2 = copy_namespaceObject[1]) === null || ref2 === void 0 ? void 0 : ref2.question,
                            text: (ref3 = copy_namespaceObject[1]) === null || ref3 === void 0 ? void 0 : ref3.answer
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full bg-slateus-400",
                            style: {
                                height: "1px",
                                opacity: "0.3"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                            title: (ref4 = copy_namespaceObject[2]) === null || ref4 === void 0 ? void 0 : ref4.question,
                            text: (ref5 = copy_namespaceObject[2]) === null || ref5 === void 0 ? void 0 : ref5.answer
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full bg-slateus-400",
                            style: {
                                height: "1px",
                                opacity: "0.3"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                            title: (ref6 = copy_namespaceObject[3]) === null || ref6 === void 0 ? void 0 : ref6.question,
                            text: (ref7 = copy_namespaceObject[3]) === null || ref7 === void 0 ? void 0 : ref7.answer
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full bg-slateus-400",
                            style: {
                                height: "1px",
                                opacity: "0.3"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                            title: (ref8 = copy_namespaceObject[4]) === null || ref8 === void 0 ? void 0 : ref8.question,
                            text: (ref9 = copy_namespaceObject[4]) === null || ref9 === void 0 ? void 0 : ref9.answer
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full bg-slateus-400",
                            style: {
                                height: "1px",
                                opacity: "0.3"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                            title: (ref10 = copy_namespaceObject[5]) === null || ref10 === void 0 ? void 0 : ref10.question,
                            text: (ref11 = copy_namespaceObject[5]) === null || ref11 === void 0 ? void 0 : ref11.answer
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var FaqSection = (FaqBlock);

;// CONCATENATED MODULE: ./src/relay/RelayDashboards.tsx
















const network = networkFromEnv();
const TestnetMarker = (param)=>{
    let { network  } = param;
    const sharedStyles = "\n    mt-4 text-center font-inter text-xl\n    font-extralight tracking-wide\n    text-slateus-400 sm:mt-0\n  ";
    switch(network){
        case "mainnet":
            return null;
        case "holesky":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: sharedStyles,
                children: "holesky testnet"
            });
        case "hoodi":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: sharedStyles,
                children: "hoodi testnet"
            });
    }
};
const RelayDashboard = (param)=>{
    let { payloadStats , payloads , validatorStats , validators  } = param;
    const { featureFlags , setFlag  } = (0,feature_flags/* useFeatureFlags */.gV)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(feature_flags/* FeatureFlagsContext.Provider */.JN.Provider, {
        value: featureFlags,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* SkeletonTheme */.y, {
            baseColor: colors/* default.slateus500 */.Z.slateus500,
            highlightColor: "#565b7f",
            enableAnimation: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderGlow/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container mx-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicErrorBoundary/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminTools/* default */.Z, {
                                setFlag: setFlag
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[48.5px] md:h-[68px]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainTitle/* default */.Z, {
                            children: "ultra sound relay"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TestnetMarker, {
                            network: network
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-16 mb-32 flex flex-col gap-y-4 xs:px-4 md:px-16",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-16 flex flex-col gap-x-4 gap-y-4 lg:flex-row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex lg:w-1/2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AddressWidget, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex lg:w-1/2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CheckRegistrationWidget, {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-x-4 gap-y-4 lg:flex-row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-col lg:w-1/2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InclusionsWidget, {
                                                payloadCount: payloadStats.count,
                                                totalValue: payloadStats.totalValue,
                                                firstPayloadAt: new Date(payloadStats.firstPayloadAt),
                                                payloads: payloads
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-col lg:w-1/2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ValidatorWidget, {
                                                ...validatorStats,
                                                validators: validators
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqSection, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactSection/* default */.Z, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var RelayDashboards = (RelayDashboard);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
;// CONCATENATED MODULE: ./src/relay/types.ts

const parsePayload = (p)=>({
        ...p,
        insertedAt: (0,parseISO/* default */.Z)(p.insertedAt)
    });
const parseValidator = (v)=>({
        ...v,
        insertedAt: (0,parseISO/* default */.Z)(v.insertedAt)
    });
const parsePayloadStats = (ps)=>({
        ...ps,
        firstPayloadAt: (0,parseISO/* default */.Z)(ps.firstPayloadAt)
    });

;// CONCATENATED MODULE: ./src/pages/relay.tsx






const RelayIndexPage = (param)=>{
    let { payloadStats , payloads , validatorStats , validators  } = param;
    const props = {
        payloadStats: parsePayloadStats(payloadStats),
        payloads: payloads.map(parsePayload),
        validatorStats,
        validators: validators.map(parseValidator)
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BasicErrorBoundary/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Ultra Sound Relay"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Ultra Sound Relay"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Permissionless, neutral, and censorship free MEV relay"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "ultra sound relay, ethereum, ETH, MEV, MEV Boost Relay"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "Permissionless, neutral, and censorship free MEV relay"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://relay.ultrasound.money"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                defer: true,
                "data-domain": "relay.ultrasound.money",
                src: "https://plausible.io/js/script.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RelayDashboards, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var relay = (RelayIndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [550,614,774,888,179], function() { return __webpack_exec__(43383); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);